<template>
    <div class="container d-flex flex-column gap-4">
        <!-- TEST -->
        <div class="row g-4" v-for="(chunk, index) in chunkedData" :key="index" >
            <div class="col-lg-4 col-md-6 col-sm-6" v-for="item in chunk" :key="item.typeId">
                <div class="card" :style="{ boxShadow: getBoxShadow(item.typeId) }">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <font-awesome-icon :icon="['fas', item.ikona]" class="icons" />
                            </div>
                            <div class="posts">
                                <p>KPK</p>
                                <p>PSH</p>
                            </div>
                            <div v-for="(itemIn, index) in documentStore.documentTypeCounts" :key="index">
                                
                                <span v-if="itemIn.typeId === item.typeId && isAllowedDomain" class="counter" >{{
                                    animatedCounters[item.typeId] || 0 }} {{item.document}}</span>

                            </div>
                        </div>
                        <p class="card-title">{{ item.titulli }}</p>
                        <p class="card-text">{{ item.pershkrimi }}</p>
                        <router-link
                            :to="{ path: '/documentet', query: { documentTypeId: item.documentTypeId, title: item.titulli } }"
                            class="card-link">
                            {{ $t('sistemi_prokurorial.documents.legislation.more_button') }}
                            <font-awesome-icon icon="fa-solid fa-arrow-right" />
                        </router-link>
                    </div>
                </div> 
            </div>
        </div>
    </div>
</template>

<script>
import { useDocumentStore } from "@/store/DocumentStore/documentStore";
import { mapState } from "pinia";

import{getWebPagesId} from"@/utils/webPage.js";

export default {
    data() {
        return {
            animatedCounters: {},
            screenWidth: window.innerWidth
        };
    },
    props: ['data'],
    computed: {
        isAllowedDomain() {
      const allowedIds = [4, 3]; // IDs for kpk, zkpsh, pa, ps
      const currentDomainId = getWebPagesId();
      return allowedIds.includes(currentDomainId);
    },
        chunkedData() {
            // Filter data to only include items with documentTypeCounts > 0
            const filteredData = this.data.filter(item => {
                const countObj = this.documentStore.documentTypeCounts.find(
                    count => count.typeId === item.typeId
                );
                return countObj && countObj.typeCount > 0;
            });

            // Përcakto chunkSize bazuar në gjerësinë e ekranit
            const width = this.screenWidth;
            let chunkSize = 3;
            if (width < 580) {
                chunkSize = 1;
            } else if (width < 992) {
                chunkSize = 2;
            } else {
                chunkSize = 3;
            }
            return filteredData.reduce((acc, item, index) => {
                const chunkIndex = Math.floor(index / chunkSize);
                if (!acc[chunkIndex]) acc[chunkIndex] = [];
                acc[chunkIndex].push(item);
                return acc;
            }, []);
        },
        ...mapState(useDocumentStore, ["documentTypeCounts", "loading", "error"]),
        documentStore() {
            return useDocumentStore();
        },
    },
    methods: {
        animateCounter(typeId, targetCount) {
            const target = parseInt(targetCount) || 0;
            const duration = 1000;
            const start = 0;
            const range = target - start;
            let startTime = null;

            const animate = (currentTime) => {
                if (!startTime) startTime = currentTime;
                const progress = currentTime - startTime;
                const percentage = Math.min(progress / duration, 1);

                this.animatedCounters[typeId] = Math.ceil(start + (range * percentage));

                if (percentage < 1) {
                    requestAnimationFrame(animate);
                }
            };

            requestAnimationFrame(animate);
        },
        getBoxShadow(typeId) {
            const colorMap = {
                45: 'var(--shadow-color-1)',
                50: 'var(--shadow-color-2)',
                47: 'var(--shadow-color-3)',
                48: 'var(--shadow-color-4)',
                12: 'var(--shadow-color-5)',
                39: 'var(--shadow-color-6)'
            };

            const shadowColor = colorMap[typeId] || 'rgba(0, 0, 0, 0.5)';
            return `0px 0px 12px 0px ${shadowColor}`;
        },
        handleResize() {
            this.screenWidth = window.innerWidth;
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    unmounted() {
        window.removeEventListener('resize', this.handleResize);
    },
    created() {
        this.documentStore.fetchDocumentTypeCounts();
    },
    watch: {
        documentTypeCounts(newVal) {
            if (newVal && newVal.length) {
                newVal.forEach(item => {
                    if (item.typeCount > 0) {
                        this.animateCounter(item.typeId, item.typeCount);
                    }
                });
            }
        }
    }
};
</script>

<style scoped>
.card {
    background: #EFF2F5 !important;
    margin: 0;
    border: transparent !important;
    border-radius: 12px !important;
    height: 280px !important;
}

.card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

.card-body div div:first-child {
    background-color: #2C3F5E;
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.icons {
    color: white;
    font-size: 24px;
}

.card-title {
    font-size: 22px;
    font-weight: 700;
    line-height: 26px;
    color: #101828;
    margin-top: 10px;
}

.card-text {
    font-size: 15px;
    line-height: 23px;
    letter-spacing: -0.2%;
    font-weight: 400;
    color: #475467;
    margin-bottom: 10px;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: auto;
}

.card-link {
    font-size: 13px;
    text-decoration: none;
    color: #2C3F5E;
    line-height: 21px;
    font-weight: 600;
}

.posts {
    position: absolute;
    right: 0;
}

.posts p {
    margin: 0 0 2px 0;
    background-color: rgba(44, 63, 94, .7);
    color: white;
    font-weight: 600;
    font-size: 15px;
    width: 60px;
    padding: 1px 10px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}

.card-body a {
    margin-top: auto;
    cursor: pointer;
}

.counter {
    display: block;
    font-size: 18px;
    font-weight: 700;
    color: #6666;
    line-height: 28px;
    position: absolute;
    right: 0;
    margin-right: 15px;
    bottom: 0;
    margin-bottom: 15px;
}
</style>